import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /*
    Josh's Custom CSS Reset, with tweaks
    https://www.joshwcomeau.com/css/custom-css-reset/
  */
    
  *, *::before, *::after {
    box-sizing: border-box;
  }
 
  * {
    margin: 0;
    padding: 0;
  }

  html {
    height: 100%;
    font-size: 62.5%;
  }

  body {
    height: 100%;
    font-size: 1.6rem;
    -webkit-font-smoothing: antialiased;
    ${(props) => {
			return {
				fontFamily: props.theme.fonts.body,
			};
		}}    
  }

  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }

  input, button, textarea, select {
    font: inherit;
  }

  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }

  #root, #__next {
    isolation: isolate;
  }
`;

export { GlobalStyle };
